/* eslint-disable prefer-promise-reject-errors */
/* eslint-disable max-len */
/* eslint-disable no-empty */
/* eslint-disable no-console */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-async-promise-executor */
/* eslint-disable no-await-in-loop */
import requester from '../../utils/requester';
import config from '../../config';
import offlineDB from '../index';


const syncOfflineEventMessages = () => new Promise(async (resolve, reject) => {

    // Algorithm of submitting offline event messages:
    // check offline files, upload them first,
    // send event message among with uploaded file uri,
    // delete event from offlineDB

    try {
        const userInfo = await requester.authNeed().contentType('application/json').get(config.serverURL + '/user');
        if (userInfo?.data?.results?.id) {
            const userId = userInfo.data.results.id;

            const offlineEventMessagesList = await offlineDB.syncEventMessages.getEventMessagesList();
            if (offlineEventMessagesList?.success) {
                if (offlineEventMessagesList?.data?.length) {
                    // just selected items related to currect user to sync
                    const filteredListByUserId = offlineEventMessagesList.data.filter(item => item?.userId?.toString() === userId.toString());
                    for (const singleMessage of filteredListByUserId) {
                        // check if open page is not related event's page, then update (because update process is syncing automatically on current event for messages)
                        if (window.location.href.indexOf(`/logs/${singleMessage.eventId}`) === -1) {
                            const modifiedSingleMessage = { ...singleMessage };
                            if (singleMessage?.attachment?.offlineDBID) {
                                // first get offline attachment from offlineDB and upload, then send the message to the server
                                try {
                                    const offlineAttachment = await offlineDB.files.getFile(singleMessage.attachment.offlineDBID);
                                    if (offlineAttachment?.success) {
                                        const formData = new FormData();
                                        formData.append('fileupload', offlineAttachment.file, (singleMessage.attachmentType === 'voice') ? `voice-${Date.now()}-log.${offlineAttachment.file.type.split('/')[1]}` : offlineAttachment.file.name);
                                        const uploadResult = await requester.contentType(false).authNeed().post(config.serverURL + '/upload', formData, true);
                                        if (uploadResult?.data?.results?.[0]?.uri) {
                                            modifiedSingleMessage.attachment = uploadResult.data.results[0].uri;
                                            try {
                                                await offlineDB.files.deleteFile(singleMessage.attachment.offlineDBID);
                                            } catch { }
                                        }
                                        else {
                                            delete modifiedSingleMessage.attachment;
                                            delete modifiedSingleMessage.attachmentType;
                                        }
                                    }
                                    else {
                                        delete modifiedSingleMessage.attachment;
                                        delete modifiedSingleMessage.attachmentType;
                                    }
                                } catch { }
                            }
                            delete modifiedSingleMessage.offlineId;
                        }
                    }
                }
            }
            else { reject('error - syncOfflineEventMessages'); }
        }
        else {
            reject('error - syncOfflineEventMessages - user not found');
        }
    }
    catch (err) {
        console.log('Error: ', err);
    }

});

export default syncOfflineEventMessages;
